import { render, staticRenderFns } from "./UserContactPersons.vue?vue&type=template&id=585bdfab"
import script from "./UserContactPersons.js?vue&type=script&lang=js&external"
export * from "./UserContactPersons.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports